import { TrackingEventName } from 'services/tracking/constants';
import { SortFields } from 'modules/conversations/constants/enums';

export const handleConversationSortTracking = ({
  track,
  sortField
}: {
  track: (event: string, data?: Record<string, unknown>) => void;
  sortField: string;
}) => {
  if (sortField === SortFields.lastActivity) {
    track(TrackingEventName.CampaignDashboardSortLastActivity);
  }

  if (sortField === SortFields.replies) {
    track(TrackingEventName.CampaignDashboardSortReplies);
  }

  if (sortField === SortFields.score) {
    track(TrackingEventName.CampaignDashboardListSortingScore);
  }
};
